import React, { useEffect, useState } from 'react';
import Box from "@material-ui/core/Box";
import Typography from "@material-ui/core/Typography";

import FieldGroup from '../../Fields/FieldGroup';
import Field from '../../Fields/Field';
import InputTextField from '../../Fields/InputTextField';
import { getFacility } from '../../../Utils/facility';


function RateDetailAccessSystemPanel({ newMode, editMode, rate, onValueChange }) {
  const [accessProvider, setAccessProvider] = useState('');

  useEffect(() => {
    const urlSearchParams = new URLSearchParams(window.location.search);
    const facilityId = urlSearchParams.get('facility');

    getFacility(facilityId).then(data => {
      setAccessProvider(data.fields.accessSystem.value.provider)
    })
  }, [])

  const onInputChange = inputId => {
    return value => {
      onValueChange(inputId, value);
    }
  }

  if(!accessProvider) {
    return  (
      <Box style={{ paddingTop: '20px' }}>
        <Typography variant='body1'>Loading access system configuration...</Typography>
      </Box>
    )
  }

  if(accessProvider === 'none') {
    return  (
      <Box style={{ paddingTop: '20px' }}>
        <Typography variant='body1'>No access system integration</Typography>
      </Box>
    )
  }

  return (
    <div class="parkchirp--rate--access-system-configuration">
      <FieldGroup label={`${accessProvider} Configuration`}>
        <Field label="Access Level" id="parkchirp--rate--access-system-access-level-code">
          <InputTextField inputId="parkchirp--rate--access-system-access-level-code"
            value={rate.fields.accessSystemMeta.value.accessLevelCode}
            onChange={onInputChange('accessLevelCode')}
            editMode={(newMode || editMode)}
          />
        </Field>
      </FieldGroup>
    </div>
  )
}

export default React.memo(RateDetailAccessSystemPanel);
